<div *ngIf="authService.isLoggedIn()"  style="display: flex;justify-content: center;height: 100vh;">
  <div class="boxwrapper" style="margin: auto;">
    <div>
      <div class="stick-top">
        <mat-toolbar>
          <mat-icon>encrypted</mat-icon> Crypto Tests
        </mat-toolbar>
        <div class="hbox lightly-padded button-bar">
          <button mat-raised-button class="primary" type="button" (click)="encrypt()" [disabled]="!decryptedValue">
            <mat-icon>encrypted_add_circle</mat-icon>
            Encrypt
          </button>
          <button mat-raised-button class="primary" type="button" (click)="decrypt()" [disabled]="!encryptedValue">
            <mat-icon>encrypted_minus_circle</mat-icon>
            Decrypt
          </button>
        </div>
      </div>

      <div class="padded">
        <table class="basicTable vtable no-shadow">
          <tbody>
          <tr>
            <th>Encrypted Value</th>
            <td><input [(ngModel)]="encryptedValue"></td>
          </tr>
          <tr>
            <th>Decrypted Value</th>
            <td><input [(ngModel)]="decryptedValue"></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
